<template>
  <div id="navegacao_principal">
    <nav class="navegacao">
      <ul class="nav_principal">
        <li v-for="(menu, ordem) in menus" :key="ordem" class="item">
          <template v-if="menu.sub.length > 0">
            <a href="javascript:void(0)" class="item-1">
              {{ menu.descricao }}
              <!-- <span>&#8964;</span> -->
              <ul class="sub-itens">
                <li v-for="(submenu, subordem) in menu.sub" :key="subordem">
                  <template v-if="submenu.sub && submenu.sub.length > 0">
                    <a href="javascript:void(0);" class="item-2">
                      {{ submenu.descricao }}
                      <span>&#8250;</span>
                      <ul v-if="submenu.sub && submenu.sub.length > 0" class="sub-itens-2">
                        <li v-for="(subsubmenu, subsubordem) in submenu.sub" :key="subsubordem">
                          <router-link
                            v-if="!!subsubmenu.url"
                            :to="{
                            path: subsubmenu.url,
                          }"
                            class="item-3"
                          >{{ subsubmenu.descricao }}</router-link>
                          <router-link
                            v-else
                            :to="{
                            path: `/categoria/${subsubmenu.slug}`,
                            params: {
                              categoria: subsubmenu.slug,
                              id: subsubmenu.id,
                              nome: subsubmenu.label,
                            },
                          }"
                            class="item-3"
                          >{{ subsubmenu.descricao }}</router-link>
                        </li>
                      </ul>
                    </a>
                  </template>
                  <template v-else>
                    <router-link
                      v-if="!!submenu.url"
                      :to="{
                      path: `${submenu.url}`,
                    }"
                      class="item-2"
                    >{{ submenu.descricao }}</router-link>
                    <router-link
                      v-else
                      :to="{
                      path: `/categoria/${submenu.slug}`,
                      params: {
                        categoria: submenu.slug,
                        id: submenu.id,
                        nome: submenu.label,
                      },
                    }"
                      class="item-2"
                    >{{ submenu.descricao }}</router-link>
                  </template>
                </li>
              </ul>
              <!-- </router-link> -->
            </a>
          </template>
          <template v-else>
            <router-link
              :to="{path: `/categoria/${menu.slug}`}"
              class="item-1 rounded"
            >{{ menu.descricao }}</router-link>
          </template>
        </li>

        <a class="busca" href="javascript:void(0)" @click="showModal(true)">
          <img src="@/assets/imgs/icone_busca.svg" alt="busca" class="icone_busca" />
        </a>

        <perfil />
      </ul>
    </nav>
    <busca />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Busca from '@/components/layout/header/Busca.vue';
import Perfil from '@/components/layout/header/Perfil.vue';
import mixins from '@/helpers/mixins';

export default {
  name: 'NavegacaoPrincipal',
  mixins: [mixins],
  props: {},

  components: {
    Busca,
    Perfil,
  },
  computed: {
    ...mapGetters({
      menus: 'menu/categorias',
      categorias: 'categoria/getCategorias',
    }),
  },
  methods: {
    ...mapActions({
      showModal: 'modal/showModal',
      menuHeader: 'menu/menuHeader',
    }),
  },
  mounted() {
    this.$nextTick(() => {
      if (this.categorias) this.menuHeader(this.categorias);
    });
  },
};
</script>

<style scoped lang="scss">
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

$espacamento: 10px;

.rounded:hover {
  border-radius: 5px !important;
}

.navegacao {
  padding-bottom: 0px;
  font-family: 'VivoType';
  font-weight: bold;

  & a {
    cursor: pointer;
    margin: 0px;
    padding: 0px;
    color: white;
    text-decoration: none;
  }

  & .nav_principal {
    @extend %flex;
    @extend %direction-row;
    @extend %justify-between;
    @extend %align-items-center;
    padding: 0px;

    & span {
      @extend %nao-selecionavel;
      color: $cor_primaria_70;
    }

    & .busca {
      @extend %flex;
      @extend %align-self-end;
      padding: 0px $espacamento;

      & img {
        margin-top: -35px;
        max-width: 40px;
        filter: grayscale(1) brightness(100);
      }
    }

    & .item {
      position: relative;
      font-size: 14px;
      // letter-spacing: 0.0vmax;
      z-index: 2000;
      padding: 0px;

      & .item-1 {
        padding: 5px 6px;
        position: relative;

        &:hover {
          background: $cor_rosa;
          border-radius: 5px 5px 0 0;
        }
      }

      & .sub-itens {
        font-weight: 500;
        font-weight: bold;
        display: none;
        position: absolute;
        background-color: $cor_rosa;
        padding: 10px 5px 10px;
        top: 27px;
        border-radius: 0 0 5px 5px;
        font-size: 14px;
        // letter-spacing: 0.05vmax;
        z-index: 2000;
        width: 160px;
        min-width: calc(100% + 10px);

        & li {
          & .item-2 {
            padding: 10px;
            position: relative;
            display: flex;

            & span {
              color: white;
              opacity: 0.5;
              font-size: 12px;
              position: absolute;
              right: 5px;
              top: 50%;
              line-height: 0px;
            }

            &:hover {
              background: $cor_rosa_dark;
              border-radius: 5px;
            }
          }
        }
      }

      & .sub-itens-2 {
        font-weight: 500;
        font-weight: bold;
        display: none;
        position: absolute;
        background-color: $cor_rosa;
        padding: 10px;
        border-radius: 0 0 5px 5px;
        font-size: 15px;
        // letter-spacing: 0.05vmax;
        z-index: 1999;
        top: 0;
        width: 160px;
        right: -160px;

        & li {
          & .item-3 {
            padding: 10px;
            position: relative;
            display: flex;
            overflow-wrap: break-word;

            & span {
              color: white;
              opacity: 0.5;
              font-size: 12px;
              position: absolute;
              right: 5px;
              top: 50%;
              line-height: 0px;
            }

            &:hover {
              background: $cor_rosa_dark;
              border-radius: 5px;
            }
          }
        }
      }
    }

    & ul:hover {
      display: block !important;
    }
  }

  & a:hover + ul {
    display: block !important;
  }

  & a:hover > ul {
    display: block !important;
  }
}

@media all and (min-width: 300px) and (max-width: 1160px) {
  #navegacao_principal {
    display: none;
  }
}
</style>
